import { Controller } from "stimulus"

// Shows the supplier questions only for non-transport companies and the primary component only for direct suppliers.
// Hidden parts are disabled fieldsets, so their fields are neither validated by the browser nor submitted.
export default class extends Controller {
  static targets = ['supplier', 'component']

  connect() {
    this.update()
  }

  update() {
    const supplier = this.checkedValue('transport') === 'no'
    const direct = supplier && this.checkedValue('supplier-type') === 'Direct Supplier'

    this.toggle(this.supplierTarget, supplier)
    this.toggle(this.componentTarget, direct)
  }

  checkedValue(identifier) {
    const radio = this.element.querySelector(`input[type="radio"][name$="[${identifier}]"]:checked`)
    return radio ? radio.value : ''
  }

  toggle(fieldset, visible) {
    fieldset.hidden = !visible
    fieldset.disabled = !visible
  }
}
